import axios from "axios";
import Table from "../../../components/Table";
import { useState, useEffect } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { ENDPOINT } from "../../../constants/endpointConstants";
import { getToken } from "../../../utils/utils";

const unitTypeOptions = [
  { value: "", label: "Seleccione un tipo de unidad" },
  { value: "Con", label: "Con" },
  { value: "g", label: "g" },
  { value: "Un", label: "Un" },
  { value: "Lt", label: "Lt" },
  { value: "mts", label: "mts" },
];

const CategoriesPage = () => {
  const [showNewCategory, setShowNewCategory] = useState(false);
  const [categories, setCategories] = useState([]);
  const [isLoadingCategories, setIsLoadingCategories] = useState(false);
  const [categoryToEdit, setCategoryToEdit] = useState(null);
  const [categoryName, setCategoryName] = useState("");
  const [categoryCustomId, setCategoryCustomId] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");
  const [unitType, setUnitType] = useState("");
  const [showDeleteCategoryConfirmation, setShowDeleteCategoryConfirmation] =
    useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [deleteError, setDeleteError] = useState("");
  const [saveError, setSaveError] = useState("");

  const getCategories = async () => {
    const token = getToken();
    try {
      setIsLoadingCategories(true);
      const { data } = await axios.get(ENDPOINT.GET_EXPENSES_CATEGORIES, token);
      setCategories(data);
      setIsLoadingCategories(false);
    } catch (error) {
      setIsLoadingCategories(false);
      console.error("Error fetching categories:", error);
    }
  };

  const saveCategory = async () => {
    const token = getToken();
    try {
      setIsLoadingCategories(true);
      const payload = {
        customId: categoryCustomId,
        name: categoryName,
        description: categoryDescription,
        unitType: unitType,
      };

      if (categoryToEdit) {
        await axios.put(
          `${ENDPOINT.GET_EXPENSES_CATEGORIES}/${categoryToEdit.id}`,
          payload,
          token
        );
      } else {
        await axios.post(ENDPOINT.GET_EXPENSES_CATEGORIES, payload, token);
      }
      setIsLoadingCategories(false);
      modalCloseCategory();
      getCategories();
    } catch (error) {
      setIsLoadingCategories(false);
      const errorMessage =
        "Error al guardar la categoría, contacte al administrador";
      setSaveError(errorMessage);
      console.error("Error saving category:", error);
    }
  };

  const deleteCategory = async () => {
    const token = getToken();
    try {
      setIsLoadingCategories(true);
      setDeleteError("");
      await axios.delete(
        `${ENDPOINT.GET_EXPENSES_CATEGORIES}/${categoryToDelete}`,
        token
      );
      setIsLoadingCategories(false);
      modalCloseDeleteCategoryConfirmation();
      getCategories();
    } catch (error) {
      setIsLoadingCategories(false);
      const errorMessage =
        "Error al eliminar la categoría, contacte al administrador";
      setDeleteError(errorMessage);
      console.error("Error deleting category:", error);
    }
  };

  const editCategory = (category) => {
    setCategoryToEdit(category);
    setCategoryName(category.name);
    setCategoryCustomId(category.customId || "");
    setCategoryDescription(category.description || "");
    setUnitType(category.unitType || "");
    setShowNewCategory(true);
  };

  const confirmDeleteCategory = (category) => {
    setCategoryToDelete(category.id);
    setShowDeleteCategoryConfirmation(true);
  };

  const modalCloseCategory = () => {
    setShowNewCategory(false);
    setCategoryToEdit(null);
    setCategoryName("");
    setCategoryCustomId("");
    setCategoryDescription("");
    setUnitType("");
    setSaveError("");
  };

  const modalCloseDeleteCategoryConfirmation = () => {
    setShowDeleteCategoryConfirmation(false);
    setCategoryToDelete(null);
    setDeleteError("");
  };

  const isFormValid =
    categoryCustomId.trim() !== "" &&
    categoryName.trim() !== "" &&
    unitType !== "";

  const spinnerCategory = () => {
    if (isLoadingCategories === false) {
      return categoryToEdit ? "Actualizar" : "Guardar";
    } else {
      return (
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      );
    }
  };

  const spinnerDeleteCategory = () => {
    if (isLoadingCategories === false) {
      return "SI";
    } else {
      return (
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      );
    }
  };

  const showModalNewCategory = () => {
    setShowNewCategory(true);
  };

  const categoriesColumns = [
    {
      name: "ID",
      key: "customId",
      type: "text",
    },
    {
      name: "Nombre Categoría",
      key: "name",
      type: "text",
    },
    {
      name: "Tipo de Unidad",
      key: "unitType",
      type: "text",
    },
    {
      name: "Acciones",
      type: "actions",
      buttons: [
        {
          iconClass: "fa-regular fa-pen-to-square",
          action: editCategory,
        },
        {
          iconClass: "fa-solid fa-trash-can",
          action: confirmDeleteCategory,
        },
      ],
    },
  ];

  useEffect(() => {
    getCategories();
  }, []);

  return (
    <div>
      <div className="d-flex justify-content-end mb-3 mt-3">
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={showModalNewCategory}
        >
          <i className="fa-solid fa-plus"></i> Nueva Categoría
        </button>
      </div>
      <Table
        columnNames={categoriesColumns}
        items={categories}
        fixSize={"t-responsive-large"}
        isLoading={isLoadingCategories}
      />
      <Modal show={showNewCategory} onHide={modalCloseCategory}>
        <Modal.Header closeButton className="style-modal-header">
          <Modal.Title className="text-modal">
            {categoryToEdit ? "Editar Categoría" : "Nueva Categoría"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group mb-3">
            <label htmlFor="categoryCustomId" className="form-label">
              ID
            </label>
            <input
              type="text"
              className="form-control"
              id="categoryCustomId"
              value={categoryCustomId}
              onChange={(e) => setCategoryCustomId(e.target.value)}
              placeholder="Ingrese ID (ej: 402)"
            />
          </div>
          <div className="form-group mb-3">
            <label htmlFor="categoryName" className="form-label">
              Nombre Categoría
            </label>
            <input
              type="text"
              className="form-control"
              id="categoryName"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              placeholder="Ingrese nombre de la categoría"
            />
          </div>
          <div className="form-group mb-3">
            <label htmlFor="categoryDescription" className="form-label">
              Descripción (Opcional)
            </label>
            <textarea
              className="form-control"
              id="categoryDescription"
              value={categoryDescription}
              onChange={(e) => setCategoryDescription(e.target.value)}
              placeholder="Ingrese descripción de la categoría"
              rows="3"
            />
          </div>
          <div className="form-group mb-3">
            <label htmlFor="unitType" className="form-label">
              Tipo de Unidad
            </label>
            <select
              className="form-control"
              id="unitType"
              value={unitType}
              onChange={(e) => setUnitType(e.target.value)}
            >
              {unitTypeOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          {saveError && (
            <div className="alert alert-danger" role="alert">
              {saveError}
            </div>
          )}
          <div className="row mt-4">
            <div className="col-6">
              <button
                type="button"
                className="btn btn-primary btn-sm w-100 text-modal"
                onClick={saveCategory}
                disabled={!isFormValid || isLoadingCategories}
              >
                {spinnerCategory()}
              </button>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-primary btn-sm w-100 text-modal"
                onClick={modalCloseCategory}
              >
                Cancelar
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showDeleteCategoryConfirmation}
        onHide={modalCloseDeleteCategoryConfirmation}
      >
        <Modal.Header closeButton className="style-modal-header">
          <Modal.Title className="text-modal"> ELIMINAR CATEGORÍA </Modal.Title>
        </Modal.Header>
        <ModalBody>
          <p className="text-center">
            ¿Está seguro que desea eliminar esta categoría?
          </p>
          {deleteError && (
            <div className="alert alert-danger" role="alert">
              {deleteError}
            </div>
          )}
          <div className="row">
            <div className="col-6">
              <button
                type="button"
                className="btn btn-primary btn-sm w-100 text-modal mt-3"
                onClick={deleteCategory}
              >
                {spinnerDeleteCategory()}
              </button>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-primary btn-sm w-100 text-modal mt-3"
                onClick={modalCloseDeleteCategoryConfirmation}
              >
                NO
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default CategoriesPage;
